import { createFileRoute, Navigate, notFound } from "@tanstack/react-router";

import { useCurrentWorkspace } from "@/features/workspaces/store/workspace.store";

export const Route = createFileRoute("/_app/w/$slug/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { slug } = Route.useParams();
  const boardKey = useCurrentWorkspace((w) => w.boards[0]?.boardKey);
  if (boardKey) {
    return <Navigate to="/w/$slug/$boardKey" params={{ slug, boardKey }} />;
  }

  throw notFound();
}
